/*
An avatar manager is a class representing a virtual avatar that can perform tasks such as
- speaking
- managing sentence queues
- interrupt speaking
An avatar can be an heygen avatar, a real-time avatar, an Azure avatar or any other type of avatar that can be controlled programmatically.
An avatar manager class controls the audio and the visuals of the avatar, including speech synthesis and viseme management.
 */
import { EventEmitter } from 'events';
export class AvatarManager extends EventEmitter {
    constructor() {
        super(...arguments);
        this.queue = [];
        this.speakingQueued = false;
    }
    interrupt() {
        this.queue = [];
        this.interruptSpeaking();
    }
    pushToSentenceQueue(text) {
        this.queue.push(text);
        this._maybeSpeakNext();
    }
    clear() {
        this.queue = [];
        console.log('🧹 Sentence queue cleared');
    }
    /**
     * Internal handler to dequeue and speak next message if idle.
     */
    async _maybeSpeakNext() {
        if (this.isSpeaking() || this.speakingQueued || this.queue.length === 0)
            return;
        this.speakingQueued = true;
        const fullText = this.queue.join(' ');
        this.queue = [];
        try {
            console.log('🗣️ Speaking:', fullText);
            await this.speak(fullText);
        }
        catch (err) {
            console.error('🗣️ Speak error:', err);
        }
        finally {
            this.speakingQueued = false;
            if (this.queue.length > 0) {
                this._maybeSpeakNext();
            }
        }
    }
}
